import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Interface_navigateTo extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_interface_navigateto">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Interface.navigateTo</h2>
              <p>
                NL.Interface.navigateTo is a method that allows you to redirect
                or navigate the user to another section of the Nexoid
                Application. The NL.Interface.navigateTo supports querystrings
                by converting an object.
              </p>
              <WorkflowCompatibility front={true} back={false} />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Interface.navigateTo Example</h2>
              <p>This example navigates the user to the home page.</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">page</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonA">"</span>
                  <span className="jsonG">/home</span>
                  <span className="jsonA">";</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">querystring</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">myVar</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">123</span>
                  <span className="jsonA">"</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsComment">
                    // Redirect to https://app.nexoid.com/home?myVar=123
                  </span>
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Interface</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">navigateTo</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">page</span>
                  <span className="jsonA">, </span>
                  <span className="nodeCode">querystring</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Interface_navigateTo;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Interface_navigateTo.js